var map = {
	"./ar.json": [
		9675,
		178
	],
	"./en.json": [
		1005
	],
	"./es.json": [
		3458,
		790
	],
	"./fa.json": [
		3331,
		967
	],
	"./pt.json": [
		6709,
		702
	],
	"./ru.json": [
		8809,
		841
	],
	"./tr.json": [
		8923,
		738
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1531;
module.exports = webpackAsyncContext;